import { Injectable } from '@angular/core';
import { Geolocation } from '@capacitor/geolocation';
import { Capacitor } from '@capacitor/core';

export interface LocationCoords {
  latitude: number;
  longitude: number;
}

@Injectable({
  providedIn: 'root',
})
export class LocationService {
  constructor() { }

  async getPosition(): Promise<LocationCoords | null> {
    // return new Promise((resolve, reject) => {
    //   navigator.geolocation.getCurrentPosition(
    //     (resp) => {
    //       resolve({ longitude: resp.coords.longitude, latitude: resp.coords.latitude });
    //     },
    //     (err) => {
    //       reject(err);
    //     }
    //   );
    // });

    const checkedPermissions = await Geolocation.checkPermissions();
    if (checkedPermissions.location === 'denied') {
      if (Capacitor.getPlatform() === 'web') {
        //requestPermissions is not implemented in web => return null
        //TODO return Result object with error info (location blocked)
        return null;
      }
      else {
        const permissions = await Geolocation.requestPermissions();
        if (permissions.location === 'denied') {
          return null;
        }
      }
    }

    try {
      const coordinates = await Geolocation.getCurrentPosition({ timeout: 5000 });
      return { longitude: coordinates.coords.longitude, latitude: coordinates.coords.latitude };
    } catch (error) {
      // if( error instanceof GeolocationPositionError)
      console.error(error);

      //dirty error handling
      //TODO return Result object with error info (location blocked)
      return null;
    }

  }
}
